export const CARD_PLATFORM_MENU_KEY = '/card-platforms'

export const CARD_PLATFORM_DESTINATIONS = [
  { key: 'slash', label: 'Slash', path: '/slash/cards?tab=groups' },
  { key: 'photonpay', label: 'PhotonPay（光子易）', path: '/photonpay?tab=cards' },
  { key: 'wasabi', label: 'WasabiCard', path: '/wasabi?tab=cards' },
] as const

const CARD_PLATFORM_ROUTE_PREFIXES = [
  '/slash/cards',
  '/slash/card-groups',
  '/photonpay',
  '/wasabi',
]

export function resolveCardPlatformMenuKey(pathname: string): string {
  const isCardPlatformRoute = CARD_PLATFORM_ROUTE_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  )
  return isCardPlatformRoute ? CARD_PLATFORM_MENU_KEY : pathname
}
